module.exports = __webpack_public_path__ + "img/general-notice.49b6d4c0.svg";